import React from "react";

import { User } from "./user";
import { RemoveIcon } from "./removeIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Resource({ projectResource, remove }: Props) {
  return (
    <div className={styles.resource} onClick={() => remove(projectResource)}>
      <User resource={projectResource.resource} />
      <div className={styles.removeResourceIconContainer}>
        <RemoveIcon className={styles.icon} />
      </div>
    </div>
  );
}

export { Resource };
